import { render, staticRenderFns } from "./returnBooksDetail.vue?vue&type=template&id=c4ca20ec&"
import script from "./returnBooksDetail.vue?vue&type=script&lang=js&"
export * from "./returnBooksDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports